import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ConfirmationModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title, 
  message, 
  confirmText = 'Delete', 
  cancelText = 'Cancel',
  type = 'danger',
  loading = false,
  children
}) => {
  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'danger':
        return { name: 'AlertTriangle', className: 'text-error' };
      case 'warning':
        return { name: 'AlertCircle', className: 'text-warning' };
      case 'info':
        return { name: 'Info', className: 'text-primary' };
      default:
        return { name: 'AlertTriangle', className: 'text-error' };
    }
  };

  const icon = getIcon();

  return (
    <>
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black/50 z-50" onClick={onClose} />
      {/* Modal */}
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div className="bg-card border border-border rounded-lg shadow-lg max-w-md w-full">
          {/* Header */}
          <div className="flex items-center gap-3 p-6 pb-4">
            <div className={`w-10 h-10 rounded-full bg-muted flex items-center justify-center ${icon?.className}`}>
              <Icon name={icon?.name} size={20} />
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-semibold text-foreground">{title}</h3>
            </div>
            <button
              onClick={onClose}
              className="text-muted-foreground hover:text-foreground transition-colors"
              disabled={loading}
            >
              <Icon name="X" size={20} />
            </button>
          </div>

          {/* Content */}
          <div className="px-6 pb-6">
            <p className="text-muted-foreground mb-4 leading-relaxed">
              {message}
            </p>
            
            {children && (
              <div className="mb-4">
                {children}
              </div>
            )}

            {/* Actions */}
            <div className="flex gap-2 justify-end">
              <Button
                variant="outline"
                onClick={onClose}
                disabled={loading}
              >
                {cancelText}
              </Button>
              <Button
                variant={type === 'danger' ? 'destructive' : 'default'}
                onClick={onConfirm}
                loading={loading}
                iconName={loading ? 'Loader' : undefined}
                iconClassName={loading ? 'animate-spin' : ''}
              >
                {confirmText}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfirmationModal;